import type { FC } from 'react';
import { lazy } from 'react';
import { Navigate, Route } from 'react-router';
import { useOptionalOrganisationService } from 'src/apis/organisation-service/use-organisation-service';
import { useOptionalSecondaryMarketService } from 'src/apis/secondary-market-service/use-secondary-market-service';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import { RootRoutes } from 'src/components/root-routes';
import { PageSpinner } from 'src/components/spinner-container';
import { BulletinBoardNoticeDetails } from 'src/pages/transport/secondary-trading/bulletin-board/details';

const TsoPage = lazy(() => import('./page'));

export const SecondaryTradingTsoOverview: FC = () => {
  const secondaryMarketService = useOptionalSecondaryMarketService();
  const organisationService = useOptionalOrganisationService();

  if (!secondaryMarketService.loaded || !organisationService.loaded)
    return <PageSpinner />;

  return (
    <RootRoutes>
      <Route
        path="/transport/secondary"
        element={<Navigate replace to="/transport/secondary/trades" />}
      />
      <Route
        path="/transport/secondary/trades"
        element={
          <TsoPage
            selectedTab="TRADES"
            secondaryMarketService={secondaryMarketService}
            organisationService={organisationService}
          />
        }
      />
      <Route
        path="/transport/secondary/proposals"
        element={
          <TsoPage
            selectedTab="PROPOSALS"
            secondaryMarketService={secondaryMarketService}
            organisationService={organisationService}
          />
        }
      />
      <Route
        path="/transport/secondary/bulletin-board"
        element={
          <TsoPage
            selectedTab="BULLETIN_BOARD"
            secondaryMarketService={secondaryMarketService}
            organisationService={organisationService}
          />
        }
      />
      <Route
        path="/transport/secondary/bulletin-board/:bulletinBoardNoticeId"
        element={<BulletinBoardNoticeDetails />}
      />
      <Route path="*" element={<ThrowNotFound />} />
    </RootRoutes>
  );
};
